import { NavigationGuardNext, Route } from 'vue-router'
import store from '@/store'

function tabletGuard(to: Route, from: Route, next: NavigationGuardNext): void {
  const isQrOnly = store.getters['subscription/isQr']

  if (isQrOnly) return next({ name: 'billing:plans' })

  return next()
}

export default tabletGuard
